import { ScheduledActivityResponse } from '../types/scheduledActivity';
import { midnightUTCToDate } from './dateHelpers';

/**
 * Calendar event type for react-big-calendar
 */
export interface CalendarEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  resource: {
    scheduledActivityId: string;
    activityId: string;
    position: number;
    imageUrl: string | null;
    description: string;
    activityTransitionId: string | null;
  };
}

/**
 * Transform scheduled activity from API to calendar event
 */
export function transformToCalendarEvent(
  scheduledActivity: ScheduledActivityResponse
): CalendarEvent {
  const eventDate = midnightUTCToDate(scheduledActivity.scheduledDate);

  return {
    id: scheduledActivity.id,
    title: `${scheduledActivity.position}. ${scheduledActivity.activity.title}`,
    start: eventDate,
    end: eventDate,
    resource: {
      scheduledActivityId: scheduledActivity.id,
      activityId: scheduledActivity.activityId,
      position: scheduledActivity.position,
      imageUrl: scheduledActivity.activity.imageUrl,
      description: scheduledActivity.activity.description,
      activityTransitionId: scheduledActivity.activityTransitionId,
    },
  };
}

/**
 * Transform array of scheduled activities to calendar events
 */
export function transformToCalendarEvents(
  scheduledActivities: ScheduledActivityResponse[]
): CalendarEvent[] {
  return scheduledActivities.map(transformToCalendarEvent);
}

/**
 * Group events by date for easier rendering
 */
export function groupEventsByDate(events: CalendarEvent[]): Map<string, CalendarEvent[]> {
  const grouped = new Map<string, CalendarEvent[]>();
  
  for (const event of events) {
    const dateKey = event.start.toISOString().split('T')[0];
    if (!grouped.has(dateKey)) {
      grouped.set(dateKey, []);
    }
    grouped.get(dateKey)!.push(event);
  }
  
  // Sort events within each date by position
  for (const [, dateEvents] of grouped) {
    dateEvents.sort((a, b) => a.resource.position - b.resource.position);
  }
  
  return grouped;
}
